import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SubjectType } from 'app/shared/models/subject-type';
import { SubjectTypeService } from 'app/shared/services/subject-type.service';
import { UserSubjectHistoryService } from 'app/shared/services/user-subject-history.service';
import { UserSubjectHistory } from 'app/shared/models/user-subject-history';
import { DateFormatPipe } from 'app/pipes/date-format.pipe';
import { Subject } from 'app/shared/models/subject';
import { SubjectLink } from 'app/shared/models/subject-link';
import { Guid } from 'app/shared/helpers/guid';
import { Observable, map } from 'rxjs';

@Component({
  selector: 'recent-history-widget',
  template: `<subject-list-widget 
            #subjectlist 
            title={{title}} 
            showSubjectTypeFilter=true 
            filterSubjectType={{filterSubjectType}}
            [data] = data$|async
            (onFilterBySubjectType)=filterBySubjectType($event) 
            (onSelect)=select($event)
            [allowEdit]=false
            [allowSelect]=false>
            noContentMessage ={{noContentMessage}}
            </subject-list-widget>`,
  })
export class RecentHistoryWidgetComponent implements OnInit {

  public title: string;
  public filterSubjectType: string;
  noContentMessage = 'No subject history for the selected subject type';
  subjectType: SubjectType;
  data$: Observable<any[]>;

  // PJT - These are here to stop errors showing in console.log  
  @Input('id') id:any;
  @Input('subjectId') subjectId:any;
  @Input('processTypeId') processTypeId:any;
  @Input('settings') settings:any;
  // PJT - End

  constructor(
    private userSubjectHistoryService: UserSubjectHistoryService,
    private subjectTypeService: SubjectTypeService, 
    private router: Router) {
  }

  ngOnInit() {
    this.title = 'Recent Subjects';

    this.data$ = this.userSubjectHistoryService.onChanged.pipe(map((data: UserSubjectHistory[]) => {
      const history = [];
      if (data.length > 0){
        data.forEach((item) => {
          if (!item.subject.archived){
            const subject = new Subject(item.subject);
            subject.subjectType = item.subjectType;
            const subjectLink = new SubjectLink();
            subjectLink.secondaryText = new DateFormatPipe('en-GB').transform(item.dateCreated);
            subjectLink.primaryLink = item.primaryLink;
            subjectLink.linkedSubject = subject;
            subjectLink.uid = Guid.newGuid(); // set dummry guid for new subjectLink object so select works on list items
            history.push(
              subjectLink,
            );
          }
        });
      }
      return history;
    }));

    this.filterSubjectType = this.userSubjectHistoryService.getCurrentType();
    this.subjectTypeService.getByName(this.filterSubjectType).subscribe((subjectType) => {
      this.subjectType = subjectType;
      this.userSubjectHistoryService.getAll(this.subjectType.name);
    });
  }

  select(row){
    this.router.navigateByUrl(`/subjects/${this.subjectType.name}/` + row.linkedSubject.uid);
  }

  filterBySubjectType(subjectTypeName: string){
    this.subjectTypeService.getByName(subjectTypeName).subscribe((subjectType) => {
      this.subjectType = subjectType;
      this.userSubjectHistoryService.getAll(subjectTypeName);
    });
  }

}
